import { UsersDTO } from '../../../redux/identity/identityTypes';
import { UserProfileFormData } from './types';

export const getDefaultValues = (
 user: UsersDTO | null | undefined,
 groups: any[],
 language: string,
): UserProfileFormData => {
 return {
  language: language || 'lt',
  email: user?.Email || '',
  phone: user?.Phone || '',
  representing: user?.Customer
   ? `${user.Customer.Email || ''} - ${user.Customer.Name || ''}`
   : '',
  group: (user?.Groups || []).map((g) => g.Name || g.Id?.toString() || ''),
  notificationMethod: [],
  twoFactorEnabled: user?.TwoFAEnabled || false,
  currentPassword: '',
  newPassword: '',
  repeatPassword: '',
 };
};

export const getLanguageOptions = (t: (key: string) => string) => [
 { value: 'lt', label: t('user.languageOptions.lt') },
 { value: 'en', label: t('user.languageOptions.en') },
];

export const getRepresentingOptions = (user: UsersDTO | null | undefined) => {
 if (!user?.Customer) {
  return [];
 }
 return [
  {
   value: `${user.Customer.Email || ''} - ${user.Customer.Name || ''}`,
   label: `${user.Customer.Email || ''} - ${user.Customer.Name || ''}`,
  },
 ];
};

export const getGroupOptions = (groups: any[]): string[] => {
 return groups.map((group) => group.Name || '').filter(Boolean);
};

export const getNotificationOptions = (
 t: (key: string) => string,
): string[] => {
 return [
  t('user.notificationOptions.sms'),
  t('user.notificationOptions.email'),
  t('user.notificationOptions.push'),
 ];
};

export const mapGroupNamesToIds = (
 groupNames: string[],
 groups: any[],
): number[] => {
 return groupNames
  .map((groupName) => {
   const foundGroup = groups.find((g) => g.Name === groupName);
   return foundGroup?.Id;
  })
  .filter((id): id is number => id !== undefined);
};

